/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ListHerdsByOrganizationQueryResponse, ListHerdsByOrganizationPathParams, ListHerdsByOrganizationQueryParams, ListHerdsByOrganization400, ListHerdsByOrganization401, ListHerdsByOrganization403, ListHerdsByOrganization404, ListHerdsByOrganization409, ListHerdsByOrganization500 } from "../../types/livestockController/ListHerdsByOrganization.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listHerdsByOrganization } from "../../client/livestockController/listHerdsByOrganization.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listHerdsByOrganizationQueryKey = (organizationId: ListHerdsByOrganizationPathParams["organizationId"] | undefined, params?: ListHerdsByOrganizationQueryParams) => [{ url: '/api/organizations/:organizationId/herds', params: {organizationId:organizationId} }, ...(params ? [params] : [])] as const

export type ListHerdsByOrganizationQueryKey = ReturnType<typeof listHerdsByOrganizationQueryKey>

export function listHerdsByOrganizationQueryOptions(organizationId: ListHerdsByOrganizationPathParams["organizationId"] | undefined, params?: ListHerdsByOrganizationQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listHerdsByOrganizationQueryKey(organizationId, params)
        return queryOptions<ListHerdsByOrganizationQueryResponse, ResponseErrorConfig<ListHerdsByOrganization400 | ListHerdsByOrganization401 | ListHerdsByOrganization403 | ListHerdsByOrganization404 | ListHerdsByOrganization409 | ListHerdsByOrganization500>, ListHerdsByOrganizationQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return listHerdsByOrganization(organizationId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List herds across the organization (optionally one farm via ?establishmentId)
 * {@link /api/organizations/:organizationId/herds}
 */
export function useListHerdsByOrganization<TData = ListHerdsByOrganizationQueryResponse, TQueryData = ListHerdsByOrganizationQueryResponse, TQueryKey extends QueryKey = ListHerdsByOrganizationQueryKey>(organizationId: ListHerdsByOrganizationPathParams["organizationId"] | undefined, params?: ListHerdsByOrganizationQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ListHerdsByOrganizationQueryResponse, ResponseErrorConfig<ListHerdsByOrganization400 | ListHerdsByOrganization401 | ListHerdsByOrganization403 | ListHerdsByOrganization404 | ListHerdsByOrganization409 | ListHerdsByOrganization500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listHerdsByOrganizationQueryKey(organizationId, params)
         

         const query = useQuery({
          ...listHerdsByOrganizationQueryOptions(organizationId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ListHerdsByOrganization400 | ListHerdsByOrganization401 | ListHerdsByOrganization403 | ListHerdsByOrganization404 | ListHerdsByOrganization409 | ListHerdsByOrganization500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}